import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import StateBy from "./components/StateBy";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route exact path="/" component={Dashboard} />
          <Route path="/state/:statename" component={StateBy} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
